import { useContext } from 'react';

import RedirectContext from './RedirectContext';

const useRedirect = () => useContext(RedirectContext);

export default useRedirect;
